export default __webpack_public_path__ + "static/media/treasure-map1.924de0b8.png";